import * as React from 'react';
import {withStyles, WithStyles} from '@material-ui/core';
import TranslateNew from '@translate/TranslateNew';
import { ChatStyle } from './Chat.style';


const tn: TranslateNew = TranslateNew.getInstance();

interface IProps extends WithStyles<typeof ChatStyle> {
  hide:boolean;
  chatId:number;
  icon:string|undefined;
  title:string;
  selectedChatId:number|undefined;
  archived:boolean;
  lastMessage:string;
  lastMessageSender:string;
  hidePreview?:boolean; // show who wrote the last message but not what it says
  lastTime:string;
  badgeCount:number
  onClick:() => void;
}

class ChatListItem extends React.Component<IProps> {

  constructor(props: IProps) {
    super(props);
  }

  public render() {
    const {classes, chatId, icon, title, selectedChatId, lastMessage,lastMessageSender, lastTime, onClick, badgeCount, 
      archived, hide, hidePreview} = this.props;

    const style:React.CSSProperties = {};
    if (selectedChatId === chatId) {
      style.backgroundColor = '#00000044';
    }
    if (hide) {
      style.maxHeight = '0px';
      style.minHeight = "0px";
    }

    return (
      <div className={classes.chatListItem} onClick={onClick} style={style}>
        <div className={classes.chatListItemIcon}>
          <div className={classes.icon} >
            {(icon !== undefined && icon.trim() !== "") && <img src={icon} className={classes.imageIcon} />}
          </div>
        </div>
        <div className={classes.chatListItemBody}>
          <div className={classes.chatListItemTopRow}>
            <div className={classes.chatListItemTitle} style={archived?{textDecoration:'line-through'}:{}}>
              {title}
            </div>
            <div className={classes.chatListItemTime}>{lastTime}</div>
          </div>
          <div className={classes.chatListItemBottomRow}>
            <div className={classes.chatListItemMessage}>
              {hidePreview
                ? tn.lang.chatPreviewHidden(lastMessageSender)
                : <><span style={{fontWeight:400}}>{lastMessageSender+": "}</span>{lastMessage}</>}
            </div>
            <div className={classes.chatListItemBadge}>
            <div className={classes.badge} style={badgeCount===0?{scale:0, pointerEvents:'none'}:{}}>{badgeCount}</div>
            </div>
          </div>
        </div>
      </div>
    );
  }

}


export default (withStyles(ChatStyle)(ChatListItem));



// WEBPACK FOOTER //
// ./src/components/chat/ChatListItem.tsx